export const translation = {
  warning: {
    customerMsg: 'Assign sales contact person before configuring order items.',
    salesMsg: 'Assign sales contact person before assigning customer.',
    allocationIncompleteMsg: 'Allocate all devices for this item before configuring it.',
    alreadySubmitted: 'Order is already submitted.',
    setPaymentAndAddressBeforeSubmit: 'Set payment method and addresses before submission',
  },
  danger: {
    setAddressesMsg: 'Assign addresses and payment option before submitting order item.',
  },
  addresses: {
    addressDetails: 'Addresses | Payment',
    delivery: 'Delivery Address',
    billing: 'Invoice Address',
    eInvoice: 'E-invoicing ',
    addNew: 'Add New',
    select: 'Select Address',
    edit: 'edit',
    change: 'change',
    back: 'back',
    vatNo: 'VAT no:',
    einNo: 'EIN no:',
    brokerInfo: 'Broker info:',
    showless: 'show less',
    showMore: 'more details',
    comment: 'comment:',
    editDelivery: 'Edit Delivery Address',
    editInvoice: 'Edit Invoice Address',
    editPayment: 'Edit Payment Method',
    sameAsDelivery: 'Same as invoice address',
    pickupAtVec: 'Pick up at VECTRONIC Aerospace GmbH',
    contactPriorDispatch: 'Please contact me prior to dispatch',
    currentAddress: 'Current address on this order',
    otherAddresses: 'All saved addresses',
    inUse: 'In use',
    willChangeTo: 'Will change to',
    useThisAddress: 'Use this address',
    update: 'Update',
  },
  paymentMethods: {
    paymentVia: 'Payment via:',
    pruchaseOrderNo: 'Purchase order no. :',
    purchaseOrder: 'Purchase order / delivery order',
    payment: 'Payment method | extra info',
    creditCard: 'Credit card (3% service fee)',
    check: 'Check',
    bankTransfer: 'Bank wire transfer',
  },
  orders: {
    noOrdersForGivenFilter: 'No orders available for a given filter',
    noOrders: "You don't have any orders yet",
  },
  confirmTitle: 'Submit confirmation',
  viewConfig: 'View',
  config: 'Configure',
  confirmOrderConfig: (amount: number, name: string) =>
    `Hereby, I confirm the selected configuration and order ${amount} ${name}!`,
  assignCustomerText: (value: string, fakturaId: string, userExisted: boolean) =>
    `Are you sure you want to assign ${value} to Order ${fakturaId}? \n The customer will receive an email notification.
      ${!userExisted ? '\n This customer has no account yet!' : ''}`,
  submitConfirmation: 'Submit confirmation',
  cancelOrder: 'Cancel Order',
  canceledOrder: 'Order Canceled',
  orderConfirmMsg: (fakturaId: string, offerNumber: string) =>
    `Are you sure to cancel ${fakturaId} ${offerNumber}`,
};
